import ProductHelpers, { setSliderEdgeClasses } from './base';
import { newModalFromSelector, newModalFromString } from '../components/modal';
import ProductBox, { generatePromoAnimatedStrip } from './productBox';
import Swiper from 'swiper/swiper-bundle';
import { slickArrowPrev, slickArrowNext, mobileSlickArrowNext, mobileSlickArrowPrev } from '../components/slickArrows';

const pdpImagesGridCrossSellContainerLimit = 3;

function isPortionOfElementInContainer(el, container) {
    const rect = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight) - containerRect.top;

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    const vertInView = (rect.top <= windowHeight) && ((rect.top + 0.66 * rect.height) >= 0);
    return vertInView;
}

function computeCurrentlyVisibleImage(evt) {
    const $imgs = $('.primary-images .productImageCarouselItem:not(.hidden)[data-index]');
    let imgIndex = -1;
    let k = -1;
    for (k of $imgs) {
        if (isPortionOfElementInContainer(k, $('.container')[0])) {
            imgIndex = +$(k).data('index');
            break;
        }
    }

    if (imgIndex === -1) {
        $('.js-icon-container').addClass('hidden');
    } else {
        $('.js-icon-container').removeClass('hidden');
        $(`.slider-pos .slide`).removeClass('active');
        $(`.slider-pos .slide[data-index=${imgIndex}]`).addClass('active');
    }
}

const addToCartFromPDP = (url, e) => {
    $.spinner().start();
    const target = $(e.currentTarget || e.target);
    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: function (response) {
            $.spinner().stop();
            const $productContainer = target;
            const $analyticsContainer = $productContainer.find('.analytics.productListingItem').data() || {};
            if (!$analyticsContainer.item_id && response.product && response.product.id) {
                $analyticsContainer.item_id = response.product.id;
            }

            // For minicart promo carousel
            var promotionId = $productContainer.closest('.product').find('.promotion-info-plp').data('promo-id') || false;
            if (response.product.available && !response.product.comingSoon) {
                var form = {
                    pid: response.product.id,
                    quantity: 1,
                    options: [],
                    promoId: promotionId,
                    parent_item_id: $analyticsContainer.parent_item_id,
                    parent_item_category4: $analyticsContainer.parent_item_category4
                };

                var url = $('#tileAddToCartUrl').data('url');
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form,
                    success: function (response) {
                        if (response) {
                            $('.minicart .minicart-quantity').removeClass('hide');
                            $('.minicart .minicart-quantity').text(response.quantityTotal);
                            localStorage.setItem('lastClickedPosition', '');
                            localStorage.setItem('listtype', 'listing');
                            // $("body, html").animate({ scrollTop: 0 }, 500, 'swing');
                            $('body').trigger('product:afterAddToCart', {
                                ...response,
                                form,
                                $productContainer,
                                $analyticsContainer
                            });
                            response.form = form;
                            $('body').trigger('count:update', response);
                        } else {
                            console.error('Ajax: Empty Response');
                        }
                        $.spinner().stop();
                        if ($('.page').data('action') === 'Cart-Show') {
                            window.location.reload();
                        }
                    },
                    error: function (err) {
                        console.error('ErrorCase: ' + err.message);
                        $.spinner().stop();
                    }
                });
            }
        },
        error: function (err) {
            console.error('ErrorCase: ' + err.message);
            $.spinner().stop();
        }
    });
};

const getProductVariationGroup = (product) => {
    if (typeof product === 'string') {
        return product.trim();
    }

    // size and color have already been selected. In this case, the variation
    // group is built with the style of the product, 'color' and the selected
    // color variation
    let pid = '';
    if (product.productType === 'variant') {
        pid = product.id.split(' ')[0].trim();
    } else if (product.productType === 'variationGroup') {
        // in this case the user only chose the color, and not the size
        pid = product.id.split('_')[0].trim();
    }
    let selectedVariation;

    for (let k in product.variationAttributes) {
        const variationAttribute = product.variationAttributes[k];
        if (variationAttribute.attributeId === 'color') {
            for (let j in variationAttribute.values) {
                if (variationAttribute.values[j].selected === true) {
                    selectedVariation = variationAttribute.values[j].value;
                    break;
                }
            }
        }
        if (selectedVariation !== undefined) {
            break;
        }
    }

    return pid + '_color_' + selectedVariation;
};

const crossSellItems = (product) => {
    if (!document.getElementById('crossSellItemsBaseUrl')) {
        return;
    }
    if ($('#rightBar').css('display') === 'none') {
        $('#Look').removeClass('hidden');
    }

    $('#rightBar').hide();

    let requestUrl = document.getElementById('crossSellItemsBaseUrl').value;
    const pid = getProductVariationGroup(product);
    const promotionId = $('.container .promo-message--tezenis').data('promotion-id');
    $.ajax({
        url: requestUrl,
        data: {
            pid: pid,
            promotionId: promotionId
        },
        method: 'GET',
        success: data => {
            const $parsed = $('<div>').html(data);
            const hasProducts = $parsed.find('.crosssell-view.js-cross-product').length > 0;

            if (!hasProducts) {
                $('#Look').addClass('hidden');
                $('#Look h4').addClass('hidden');
                $('.completeYourLookContainer h6').addClass('hidden');
                $('.suggested-products-default-title').addClass('hidden');
                $('.js-cross-sell-img-grid').addClass('hide');
                return;
            }

            document.getElementById('crossSellContainer').innerHTML = data;

            if (Foundation.MediaQuery.atLeast('medium')) {
                // layout for images grid cross sell container START
                var temp = document.createElement('div');
                temp.innerHTML = data;
                var crossSellSliderType = temp.querySelector('#promoSlider') ? '#promoSlider' : '#lookSlider';
                var images = temp.querySelectorAll(crossSellSliderType + ' .product-tile .tile-image');

                if (images && images.length) {
                    var imageGrid = document.getElementById('crossSellContainerImgGrid');
                    if (!imageGrid) {
                        return;
                    }

                    imageGrid.innerHTML = '';
                    var limit = images.length > pdpImagesGridCrossSellContainerLimit ? pdpImagesGridCrossSellContainerLimit : images.length;

                    for (var i = 0; i < limit; i++) {
                        var wrapper = document.createElement('div');
                        wrapper.className = 'cross-sell-img-item';
                        wrapper.appendChild(images[i].cloneNode(true));
                        imageGrid.appendChild(wrapper);
                    }
                }
                // images grid cross sell END
            }

            $('#rightBar').show();
            if (document.querySelectorAll('.crosssell-view.js-cross-product').length > 4) {
                $('.suggestedProductsContainer--tezenis .show-more').show();
            }

            $('.suggestedProductsContainer--tezenis .show-more').on('click', (evt) => {
                evt.preventDefault();
                $('.crosssell-view.js-cross-product').removeClass('hide-for-medium');
                $('.suggestedProductsContainer--tezenis .show-more').addClass('hide');
                $('body').trigger('product:crossSellLoaded', { loadHead: false });
            });

            $('body').off('click', '.quick-buy-sizes-item');
            $('body').off('click', '#crossSellContainer .js-pdp-link, #crossSellContainerMinicart .js-pdp-link');
            $('body').on('click', '#crossSellContainer .js-pdp-link, #crossSellContainerMinicart .js-pdp-link', (evt) => {
                if (!$(evt.target.parentElement).hasClass('plp-wishlist') && $(evt.target).data('variant') !== undefined) {
                    evt.preventDefault();
                    var list = $(evt.currentTarget).find('.analytics.productListingItem').data().list;
                    var position = $(evt.currentTarget).find('.analytics.productListingItem').data().position;
                    var coupon = $(evt.currentTarget).find('.analytics.productListingItem').data().coupon;
                    const url = evt.currentTarget.dataset.quickview + '&list=' + list + '&position=' + position + '&coupon=' + coupon;
                    var variantUrl = $(evt.target).data('variant');
                    addToCartFromPDP(variantUrl, evt);
                }
            });

            $('#crossSellVariation').html(data);
            ['#promoSlider', '#lookSlider'].forEach(function (selector) {
                const $slider = $(selector).filter(function () {
                    return $(this).closest('.minicart').length === 0;
                });

                if ($slider.length) {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('destroy');
                    }

                    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
                        setSliderEdgeClasses(slick, currentSlide);
                    });

                    $slider.slick({
                        slidesToShow: 4.8,
                        slidesToScroll: 1,
                        infinite: false,
                        draggable: true,
                        slide: '.crosssell-view',
                        arrows: true,
                        prevArrow: slickArrowPrev,
                        nextArrow: slickArrowNext,
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 2.25,
                                    slidesToScroll: 1,
                                    infinite: false,
                                    draggable: true
                                }
                            }
                        ]
                    });
                }
            });

            let titleText;
            let promoPill;
            let isCompletePromo = false;
            if ($('.promoCrossSellEnabled').length) {
                $('.js-promo-container').removeClass('hidden');
                $('.js-promo-text').removeClass('hidden');
                titleText = $('.js-promo-text').text();
                promoPill = $('.descriptionSidebar--tezenis .js-promo-container');
                $('.js-pdp-complete-mobile.js-isPromoFilmstrip').removeClass('hidden');
                const $carouselContainer = $('.suggested-products');
                var promoName = $('.container .promo-message--tezenis:first').text().trim();
                if (promoName.toLowerCase().indexOf('promo') === 0) {
                    promoName = promoName.substring(6);
                }
                $carouselContainer.find('.suggested-products-promo-message').text(promoName);
                isCompletePromo = true;
            } else {
                $('.js-pdp-complete-mobile.js-isNotPromoFilmstrip').removeClass('hidden');
                $('.js-default-container').removeClass('hidden');
                $('.js-default-text').removeClass('hidden');
                titleText = $('.js-default-text').text();
            }
            $('body').trigger('product:crossSellLoaded', { loadHead: true, isCompletePromo: isCompletePromo });
            $('.js-cross-sell-modal-header').text(titleText);
            if ($('.js-cross-sell-modal-header').find('.promo-pill-cloned').length === 0 && promoPill && promoPill.length) {
                const clonedPill = promoPill.clone().addClass('promo-pill-cloned').find('.text-promotion').text(promoName).end();
                $('.js-cross-sell-modal-header').append(clonedPill);
            }
            crossSellSlider();
        },
        error: () => {
            $.spinner().stop();
            $('body').trigger('product:crossSellError');
        }
    });
};
const youMayAlsoLikeItems = () => {
    if ($('#rightBar').css('display') === 'none') {
        $('#Look').removeClass('hidden');
    }

    $('#rightBar').hide();

    const $googleConfig = $('.js-googleRecommendationConfig');
    if ($googleConfig.length) {
        const url = $('#googleRecommendationsUrl').val();
        const servingConfig = $googleConfig.data('servingConfig');
        const nodeToAppendTo = $googleConfig.data('nodeToAppendTo');
        const cgid = $('#primaryCategoryId').val();
        const sku = $('#variationGroupSku').val();
        const route = $('.page').data('action');

        if (!url) {
            return;
        }

        const $analyticsContainer = $('.analytics.product').data();
        $.ajax({
            type: 'GET',
            url: url,
            data: {
                cgid: cgid,
                sku: sku,
                route: route,
                servingConfig: servingConfig,
                parent_item_id: $analyticsContainer ? $analyticsContainer.item_id : null,
                parent_item_category4: $analyticsContainer ? $analyticsContainer.item_category4 : null
            },
            success: function (html) {
                const $outputContainer = $(nodeToAppendTo).find('.google-recommendation-results');
                if (!$outputContainer.length) {
                    $('<div class="google-recommendation-results"></div>').appendTo(nodeToAppendTo);
                }
                $(nodeToAppendTo).find('.google-recommendation-results').empty().append(html);

                $('.einstein-carousel-not-cart .cc-product-tile-carousel').each(function () {
                    const $carousel = $(this);

                    if ($carousel.hasClass('slick-initialized')) {
                        return;
                    }

                    const $prevBtn = $carousel.closest('.image-container').find('.js-image-nav--prev');
                    const $nextBtn = $carousel.closest('.image-container').find('.js-image-nav--next');

                    $prevBtn.add($nextBtn).on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    $carousel.slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow: $prevBtn,
                        nextArrow: $nextBtn,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false
                                }
                            }
                        ]
                    });
                });
            },
            error: function () {
                $('#youMayAlsoLikeContainer').addClass('hidden');
            }
        });
    }
};

const productDetailSlider = () => {
    if ($('.product-wrapper--tezenis').length && Foundation.MediaQuery.is('small only')) {
        var mainImageSwiper = new Swiper('.js-pdpCarousel', {
            loop: false,

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            }
        });
    }

    $('body').on('click', '.pdpCarousel__thumbnail', function (e) {
        $('.pdpCarousel__thumbnail').removeClass('active');
        $(e.currentTarget).addClass('active');
        mainImageSwiper.slideTo($(this).index(), 1000, false);
    });
};

const zoomProductImage = () => {
    let isZoomModalOpen = false;

    $('body').on('click', '.productImageCarouselItem', (e) => {
        if (isZoomModalOpen) return;
        isZoomModalOpen = true;
        var modal = newModalFromSelector('zoom-slider', false, ['cc-pdp__zoomImage__modal']);

        modal.open();

        const clickedImg = e.currentTarget;
        const indexCurrentSlide = clickedImg.dataset.index;

        if ($('.cc-pdp__zoomImage__slider').length) {
            $('.cc-pdp__zoomImage__slider .swiper-slide img').each(function () {
                if ($(this).parent('.swiper-zoom-container').length === 0) {
                    $(this).wrap('<div class="swiper-zoom-container"></div>');
                }
            });

            let zoomImageSwiper = new Swiper('.cc-pdp__zoomImage__slider', {
                slidesPerView: 1,
                loop: false,
                initialSlide: indexCurrentSlide,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                zoom: {
                    maxRatio: 3,
                    toggle: true
                },
                on: {
                    afterInit: function () {
                        setTimeout(() => {
                            if (Foundation.MediaQuery.atLeast('medium')) {
                                $('.cc-pdp__zoomImage__slider .swiper-slide img').each(function (i, el) {
                                    let src = $(el).attr('src');
                                    $(el).attr('src', src);
                                });
                            }
                        }, 300);
                    }
                }
            });

            if (!Foundation.MediaQuery.atLeast('medium')) {
                setTimeout(() => {
                    $(zoomImageSwiper.pagination.el).css('top', window.innerHeight - 33);
                }, 100);
            }
        }

        $(modal.modalBox).find('.js-zoom-slider-close').off('click').on('click', function (e) {
            modal.close();
            $('html').css('overflow-y', 'auto');
            $('.cc-pdp__zoomImage__slider')[0].swiper.destroy(false);
            resetImageSize();
            $('#zoom-slider').css('display', 'none');
            isZoomModalOpen = false;
        });
    });
};

const crossSellSlider = () => {
    if ($('#crossSellVariation .js-cross-product').length) {
        if ($('#crossSellContainer').hasClass('slick-initialized')) {
            $('#crossSellContainer').slick('unslick');
        }
        ['#promoSlider', '#lookSlider'].forEach(function (selector) {
            const $slider = $('#crossSellVariation').find(selector);

            $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
                setSliderEdgeClasses(slick);
            });

            if ($slider.length) {
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('destroy');
                }

                $slider.slick({
                    slidesToShow: 4.8,
                    slidesToScroll: 1,
                    infinite: false,
                    draggable: true,
                    slide: '.crosssell-view',
                    arrows: true,
                    prevArrow: mobileSlickArrowPrev,
                    nextArrow: mobileSlickArrowNext,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2.25,
                                slidesToScroll: 1,
                                infinite: false,
                                draggable: true
                            }
                        }
                    ]
                });
            }
        });
    }
};

const videoListener = () => {
    const $videoBlockContainer = $('.product-detail .primary-images .js-productVideoContainer');
    if ($videoBlockContainer.length > 0 && !$videoBlockContainer.hasClass('hidden')) {
        var myVideo = $videoBlockContainer.find('video')[0];
        myVideo.onended = function () {
            myVideo.currentTime = 0;
        };
        myVideo.onplaying = function () {
            $videoBlockContainer.addClass('isVideoPlayed');
            myVideo.autoplay = false;
        };
    }
};

const addProductToWishlist = () => {
    const addTo = document.querySelector('.coming-soon-banner .button.add-to-wish-list');
    const heart = document.querySelector('#descriptionSidebar.descriptionSidebar--tezenis .descriptionSidebar__details .name-wishlist .add-to-wish-list');

    if (!addTo || !heart) {
        return;
    }

    addTo.addEventListener('click', () => {
        addTo.classList.add('hide');
    });
    heart.addEventListener('click', () => {
        addTo.classList.remove('hide');
    });
};

const videoOnChangeAttribute = (res, $productContainer) => {
    if ($productContainer.find('.js-productVideoContainer').length > 0) {
        $productContainer.find('.js-productVideoContainer').remove();
    }
    if (res.product.videoURL) {
        $('.pdpCarousel__slider-container .pdpCarousel__slider').addClass('carouselWithVideo');
        if ($('.js-productVideoContainerOuter').length > 0) {
            let tmpl = $('.js-productVideoContainerOuter').clone()[0];
            tmpl.setAttribute('class', 'pdpCarousel__slide productVideoContaner js-productVideoContainer');
            let videoBlock;
            if (Foundation.MediaQuery.is('small only')) {
                $productContainer.find('.primary-images .js-pdpCarousel .swiper-wrapper .swiper-slide').children().first().replaceWith(tmpl);
                $productContainer.find('.pdpCarousel__slide .js-productVideoContainer source').attr('src', res.product.videoURL);
                videoBlock = $productContainer.find('.pdpCarousel__slide .js-productVideoContainer video');
            } else {
                $productContainer.find('.primary-images .pdpCarousel__slider').children().first().replaceWith(tmpl);
                $productContainer.find('.primary-images .js-productVideoContainer source').attr('src', res.product.videoURL);
                videoBlock = $productContainer.find('.primary-images .js-productVideoContainer video');
            }
            if (videoBlock && videoBlock.length > 0) {
                videoBlock[0].load();
            }
        }
        videoListener();
    } else {
        $('.pdpCarousel__slider-container .pdpCarousel__slider').removeClass('carouselWithVideo');
    }
};

const updateProductDetailSlider = (res, $productContainer) => {
    if ($('.product-wrapper--tezenis').length && !$productContainer.hasClass('product-quickview')) {
        videoOnChangeAttribute(res, $productContainer);
        productDetailSlider();
    }
};

/* ZOOM */
function resetImageSize() {
    $('.cc-pdp__zoomImage__item').removeClass('cc-pdp__zoomImage__scaleUp').removeClass('cc-pdp__zoomImage__scaleDown').addClass('cc-pdp__zoomImage__initialScale');
    $('.cc-pdp__zoomImage__zoomOut').removeClass('disabled');
    $('.cc-pdp__zoomImage__zoomIn').removeClass('disabled');
    $('.cc-pdp__zoomImage__slider').find('.cc-pdp__zoomImage__img').css('transform', 'translate(0, 0)');
}

function addEventListenerForZoom() {
    $('body').on('click', '.cc-pdp__zoomImage__zoomIn', function () {
        if ($('.cc-pdp__zoomImage__item.swiper-slide-active').hasClass('cc-pdp__zoomImage__initialScale')) {
            $('.cc-pdp__zoomImage__slider').find('.cc-pdp__zoomImage__item').removeClass('cc-pdp__zoomImage__initialScale').addClass('cc-pdp__zoomImage__scaleUp');
            $('.cc-pdp__zoomImage__zoomIn').addClass('disabled');
        } else if ($('.cc-pdp__zoomImage__item.swiper-slide-active').hasClass('cc-pdp__zoomImage__scaleDown')) {
            $('.cc-pdp__zoomImage__slider').find('.cc-pdp__zoomImage__item').removeClass('cc-pdp__zoomImage__scaleDown').addClass('cc-pdp__zoomImage__initialScale');
            $('.cc-pdp__zoomImage__zoomOut').removeClass('disabled');
        }
    });

    $('body').on('click', '.cc-pdp__zoomImage__zoomOut', function () {
        if ($('.cc-pdp__zoomImage__item.swiper-slide-active').hasClass('cc-pdp__zoomImage__initialScale')) {
            $('.cc-pdp__zoomImage__slider').find('.cc-pdp__zoomImage__item').removeClass('cc-pdp__zoomImage__initialScale').addClass('cc-pdp__zoomImage__scaleDown').find('.zoom').css({ 'margin-top': '0' });
            $('.cc-pdp__zoomImage__zoomOut').addClass('disabled');
        } else if ($('.cc-pdp__zoomImage__item.swiper-slide-active').hasClass('cc-pdp__zoomImage__scaleUp')) {
            $('.cc-pdp__zoomImage__slider').find('.cc-pdp__zoomImage__item').removeClass('cc-pdp__zoomImage__scaleUp').addClass('cc-pdp__zoomImage__initialScale');
            $('.cc-pdp__zoomImage__zoomIn').removeClass('disabled');
        }
    });

    $('body').on('click', '.cc-pdp__zoomImage__item', function () {
        if ($('.cc-pdp__zoomImage__item.swiper-slide-active').hasClass('cc-pdp__zoomImage__initialScale')) {
            $('.cc-pdp__zoomImage__zoomIn').trigger('click');
        }
    });

    $('body').on('click', '.cc-pdp__zoomImage__itemThumbnails', function (e) {
        $('.cc-pdp__zoomImage__itemThumbnails .cc-pdp__zoomImage__thumbnail').removeClass('active');
        var $thumbnail = $(e.currentTarget).find('.cc-pdp__zoomImage__thumbnail');
        $thumbnail.addClass('active');
        $('.cc-pdp__zoomImage__slider')[0].swiper.slideTo($(e.currentTarget).index(), 1000, false);

        var sku = $('.product-detail-keeper').data('pid');
        if (sku) {
            var photoType = ($thumbnail.attr('src') || '').indexOf('wear') > -1 ? 'weared' : 'still_life';
            $('body').trigger('product:changeZoomImage', {
                sku: sku,
                photoType: photoType
            });
        }
    });
}

const populateCareAndMaintananceText = () => {
    if ($('.js-composition-info--ww').length > 0) {
        document.querySelectorAll('.icon-wash').forEach(el => {
            const title = el.getAttribute('title');
            if (title && !el.querySelector('.icon-wash__text')) {
                const span = document.createElement('span');
                span.className = 'icon-wash__text';
                span.textContent = title;
                el.appendChild(span);
            }
        });
    }
};

/* END ZOOM */
class Product {
    run() {
        ProductHelpers.run();
        ProductBox.gotoPDP();
        this.updateAttributesAndDetails();
        this.showSpinner();
        this.updateAttribute();
        this.updateAddToCart();
        this.updateAvailability();
        this.getCrossSellItems();
        this.getyouMayAlsoLikeItems();
        this.afterUpdateImages();
        this.recentlyViewedItems();
        this.productRecommendations();
        this.quickAdd();
        this.matchWith();
        this.wishlistIcon();
        videoListener();
        generatePromoAnimatedStrip();
        productDetailSlider();
        addProductToWishlist();
        this.upsellCarousel();
        this.openPDPAccordion();
        this.PDPaccordion();
        this.openModalSize();
        this.closeModalSize();
        addEventListenerForZoom();
        zoomProductImage();
        populateCareAndMaintananceText();
        this.updateNewPill();
    }

    updateNewPill () {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            const container = $('.js-new-msg').closest('.pdp-message-custom-label');
            container.toggleClass('hidden', !response.data.product.New);
        });
    }

    upsellCarousel() {
        $('.upsell-carousel').slick({
            slide: '.product',
            dots: false,
            infinite: false,
            draggable: false,
            speed: 500,
            slidesToShow: 4.8,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('#upsellRecommendation .prev-button-ei'),
            nextArrow: $('#upsellRecommendation .next-button-ei'),
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    draggable: true
                }
            }]
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('#upsellRecommendation .prev-button-ei, #upsellRecommendation .next-button-ei').addClass('transparent');
        }).on('afterChange', function (event, slick, currentSlide) {
            $('#upsellRecommendation .prev-button-ei, #upsellRecommendation .next-button-ei').removeClass('transparent');
        });
    }

    quickAdd() {
        $('body').on('click', '.js-quickview-link', (evt) => {
            const url = evt.currentTarget.dataset.href;
            var variantUrl = $(evt.target).data('variant');
            addToCartFromPDP(variantUrl, evt);
        });
    }

    matchWith () {
        $('body').on('click', '.js-match-with', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let htmlContent = $('.suggestedProductsContainer.hide-for-small-only .js-pdp-cross-sell-modal').html();
            const modal = newModalFromString(htmlContent, false, ['pdp-cross-sell', 'layer-complete-your-promo-modal']);
            $(modal.modalBox).addClass(
                'rightModalAttribute'
            );
            modal.open();

            $(modal.modalBox).on('click', '.js-pdpCrossSell-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });

            $('body').trigger('product:buyLookBtnAnalytics', true);
        });
    }

    wishlistIcon() {
        $('body').on('click', '.plp-wishlist', (evt) => {
            evt.preventDefault();
            $(evt.currentTarget).addClass('added');
        });
    }

    openPDPAccordion() {
        $('body').on('click', '.with-accordion', (evt) => {
            evt.preventDefault();
            if ($(evt.currentTarget).hasClass('active')) {
                $(evt.currentTarget).removeClass('active');
            } else {
                $(evt.currentTarget).addClass('active');
            }
        });
    }

    PDPaccordion() {
        $('body').on('click', '.js-accordion-title', (evt) => {
            if ($(evt.currentTarget).closest('.js-accordion-size-wrapper').length && !Foundation.MediaQuery.atLeast('large')) {
                $(evt.currentTarget).closest('.js-accordion-wrapper').addClass('open-modal');
            } else {
                if (!$(evt.currentTarget).closest('.js-accordion-wrapper').hasClass('active-accordion')) {
                    $('body').trigger('product:moreInfoToggle', $(evt.currentTarget).closest('.js-accordion-wrapper').data('analytics-info'));
                }
                $(evt.currentTarget).closest('.js-accordion-wrapper').toggleClass('active-accordion');
            }
            if (!$(evt.currentTarget).closest('.js-accordion-wrapper').hasClass('active-accordion')) {
                $(evt.currentTarget).attr('aria-expanded', false);
            } else {
                $(evt.currentTarget).attr('aria-expanded', true);
            }
        });
    }

    openModalSize () {
        $('body').on('click', '.cart-and-ipay button.add-to-cart:not(.ready-to-buy)', (evt) => {
            if ($('.js-accordion-size-wrapper').length && !Foundation.MediaQuery.atLeast('large')) {
                $('.js-accordion-wrapper').addClass('open-modal');
                $('body').addClass('is-modal-opened');
            }
        });
    }

    closeModalSize() {
        $('body').on('click', '.close-modal-size, .js-variation-attribute-bag-modal-close', (evt) => {
            if ($('.js-accordion-size-wrapper').length && !Foundation.MediaQuery.atLeast('large')) {
                $('.js-accordion-wrapper').removeClass('open-modal');
                $('body').removeClass('is-modal-opened');
                $('.js-accordion-size-wrapper .add-to-cart.button').show();
                if ($('.js-accordion-size-wrapper .js-createPersonalizationConfirmSize').length > 0) {
                    $('.js-accordion-size-wrapper .js-createPersonalizationConfirmSize').addClass('d-none');
                }
                if ($('.js-accordion-size-wrapper .js-createSmartGiftConfirmSize').length > 0) {
                    $('.js-accordion-size-wrapper .js-createSmartGiftConfirmSize').addClass('d-none');
                }
            }
        });
    }

    recentlyViewedItems() {
        $('body').on('click', '.recentlyviewed .js-pdp-link', (evt) => {
            if (Foundation.MediaQuery.is('medium') && !$(evt.target.parentElement).hasClass('plp-wishlist') && $(evt.target).data('variant') !== undefined) {
                evt.preventDefault();
                var list = $(evt.currentTarget).find('.analytics.productListingItem').data().list;
                var position = $(evt.currentTarget).find('.analytics.productListingItem').data().position;
                var coupon = $(evt.currentTarget).find('.analytics.productListingItem').data().coupon;
                const url = evt.currentTarget.dataset.quickview + '&list=' + list + '&position=' + position + '&coupon=' + coupon;
                var variantUrl = $(evt.target).data('variant');
                addToCartFromPDP(variantUrl, evt);
            }
        });
    }

    productRecommendations() {
        $('body').on('click', '#ProdRecommendation .js-pdp-link, #upsellRecommendation .js-pdp-link', (evt) => {
            if (Foundation.MediaQuery.is('medium') && !$(evt.target.parentElement).hasClass('plp-wishlist') && $(evt.target).data('variant') !== undefined
                // prevents double add to cart call, quickView.js achieves the same functionality
                && $('.page').data('action') !== 'Cart-Show') {
                evt.preventDefault();
                var list = $(evt.currentTarget).find('.analytics.productListingItem').data().list;
                var position = $(evt.currentTarget).find('.analytics.productListingItem').data().position;
                var coupon = $(evt.currentTarget).find('.analytics.productListingItem').data().coupon;
                const url = evt.currentTarget.dataset.quickview + '&list=' + list + '&position=' + position + '&coupon=' + coupon;
                var variantUrl = $(evt.target).data('variant');
                addToCartFromPDP(variantUrl, evt);
            }
        });
    }

    getCrossSellItems() {
        $('body').on('product:afterAttributeSelect', (e, data) => {
            if (data.container.hasClass('product-quickview')) {
                return;
            }
            if (data.type === 'color') {
                // In all other casesa it's useless, they do not change
                crossSellItems(data.data.product, data.data.queryString);
            }
        });
    }

    getyouMayAlsoLikeItems() {
        $('body').on('product:afterAttributeSelect', (e, data) => {
            if (data.container.hasClass('product-quickview')) {
                return;
            }
            if (data.type === 'color') {
                // In all other casesa it's useless, they do not change
                youMayAlsoLikeItems();
            }
        });
    }

    afterUpdateImages() {
        $('body').on('product:afterAttributeSelect', (e) => {
            computeCurrentlyVisibleImage(e);
        });
    }

    updateAttributesAndDetails() {
        $('body').on('product:statusUpdate', (e, data) => {
            const $productContainer = $(`.product-detail[data-pid="${data.id}"]`);

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .item-description .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    }

    showSpinner() {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', () => {
            $.spinner().start();
        });
    }

    updateAttribute() {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if ($('.bonus-product-modal').length > 0) {
                response.container.closest('.choice-of-bonus-product').data('pid', response.data.product.id);
            } else if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    }

    updateAddToCart() {
        $('body').on('product:updateAddToCart', function (e, response) {
            if (Foundation.MediaQuery.atLeast('medium')) {
                $('button.add-to-cart, button.add-to-cart-global')
                    .not('.add-mobile-soldout-add')
                    .prop('disabled', ((!response.product.available) || response.product.comingSoon));
                $('button.add-to-cart, button.add-to-cart-global')
                    .data('disabled', !response.product.readyToOrder);
            } else {
                $('button.add-to-cart, button.add-to-cart-global')
                    .not('.add-mobile-soldout-add')
                    .prop('disabled', false);
            }
        });
    }

    updateAvailability() {
        $('body').on('product:updateAvailability', (e, response) => {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            let showSizeMessageForSmall = true;

            var isSizeSelected = false;
            response.product.variationAttributes.forEach(varAttr => {
                if (varAttr.attributeId === 'size') {
                    varAttr.values.forEach(value => {
                        if (value.selected) {
                            isSizeSelected = true;
                        }
                    });
                }
            });
            if (isSizeSelected) {
                $('.availability-msg-for-small', response.$productContainer)
                    .empty()
                    .html(response.message)
                    .removeClass('text-brand-blue')
                    .removeClass('text-salmon')
                    .removeClass('text-brand-green')
                    .removeClass('text-brand-red')
                    .addClass('text-medium-gray')
                    .addClass('hidden');
            }

            if (response.product.availability.lowStockItems) {
                showSizeMessageForSmall = false;
            }

            if (response.product.available && response.product.readyToOrder) {
                showSizeMessageForSmall = false;
                if (response.product.availability.lowStockItems) {
                    $('.availability-msg', response.$productContainer)
                        .addClass('text-salmon')
                        .removeClass('text-brand-green')
                        .removeClass('text-brand-red')
                        .removeClass('text-brand-blue')
                        .removeClass('text-medium-gray')
                        .addClass('hidden');

                    // small version
                    $('.availability-msg-for-small', response.$productContainer)
                        .addClass('text-salmon')
                        .removeClass('text-brand-green')
                        .removeClass('text-brand-red')
                        .removeClass('text-brand-blue')
                        .removeClass('text-medium-gray')
                        .addClass('hidden');
                } else {
                    $('.availability-msg', response.$productContainer)
                        .addClass('text-brand-green')
                        .removeClass('text-brand-red')
                        .removeClass('text-brand-blue')
                        .removeClass('text-medium-gray')
                        .addClass('hidden');

                    // small version
                    $('.availability-msg-for-small', response.$productContainer)
                        .addClass('text-brand-green')
                        .removeClass('text-brand-red')
                        .removeClass('text-brand-blue')
                        .removeClass('text-medium-gray')
                        .addClass('hidden');
                }
            } else if (response.product.comingSoon) {
                $('.availability-msg', response.$productContainer)
                    .addClass('text-medium-gray')
                    .removeClass('text-brand-green')
                    .removeClass('text-brand-red')
                    .removeClass('text-brand-blue')
                    .addClass('hidden');
            } else if (response.product.isSoldout) {
                $('.availability-msg', response.$productContainer)
                    .html(document.getElementById('lbl-soldout-message').innerHTML)
                    .addClass('text-medium-gray')
                    .removeClass('text-brand-blue')
                    .removeClass('text-brand-green')
                    .removeClass('text-brand-red')
                    .addClass('hidden');
            }

            $('#choose-size-message').toggle(showSizeMessageForSmall);

            if ($('.global-availability').length) {
                const allAvailable = $('.product-availability').toArray()
                    .every(item => { return $(item).data('available'); });

                const allReady = $('.product-availability').toArray()
                    .every(item => { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock).addClass('text-medium-gray');
            }
        });
    }
}

const product = new Product();
export default product;
export { crossSellItems, youMayAlsoLikeItems, computeCurrentlyVisibleImage, updateProductDetailSlider };
